import React from 'react';
import './Header.css';
import ItmonkeysVideo from '../../../assets/videos/itmonkeys-main-bg.mp4';

interface HeaderProps {
  title: string;
  mobileTitle?: string;
  subtitle: string;
  mobileSubtitle?: string;
  className?: string;
  hideWaves?: boolean;
}

const Header: React.FC<HeaderProps> = ({ title, mobileTitle, subtitle, mobileSubtitle, className, hideWaves = false }) => {
  const [windowWidth, setWindowWidth] = React.useState(window.innerWidth);

  React.useEffect(() => {
    const handleResize = () => {
      setWindowWidth(window.innerWidth);
    };

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const styles = {
    waves: {
      position: 'absolute' as const,
      bottom: 0,
      left: 0,
      width: '100%',
      marginBottom: -3,
      minHeight: 100,
      maxHeight: 100,
    },
  };

  return (
    <div
      className={`header ${className || ''}`}
      style={{
        background: `url(${process.env.PUBLIC_URL}/blue-bg.png) center center / cover no-repeat`,
      }}
    >
      <style>
        {`
          @keyframes move-forever {
            0% {
              transform: translate3d(-90px,0,0);
            }
            100% {
              transform: translate3d(85px,0,0);
            }
          }
          .parallax > use {
            animation: move-forever 25s cubic-bezier(.55,.5,.45,.5) infinite;
          }
          .parallax > use:nth-child(1) {
            animation-delay: -2s;
            animation-duration: 7s;
          }
          .parallax > use:nth-child(2) {
            animation-delay: -3s;
            animation-duration: 10s;
          }
          .parallax > use:nth-child(3) {
            animation-delay: -4s;
            animation-duration: 13s;
          }
          .parallax > use:nth-child(4) {
            animation-delay: -5s;
            animation-duration: 20s;
          }
          .parallax > use:nth-child(5) {
            animation-delay: -6s;
            animation-duration: 15s;
          }
          .parallax > use:nth-child(6) {
            animation-delay: -7s;
            animation-duration: 9s;
          }
          .parallax > use:nth-child(7) {
            animation-delay: -8s;
            animation-duration: 25s;
          }
        `}
      </style>

      <video className="background-video" autoPlay loop muted playsInline>
        <source src={ItmonkeysVideo} type="video/mp4" />
      </video>

      <div className="header-content header-wrapper">
        <div className="landing-title-container">
          <h1 className="h1-landing" dangerouslySetInnerHTML={{ 
            __html: windowWidth <= 635 && mobileTitle ? mobileTitle : title 
          }} />
          <h4 className="h4-landing" dangerouslySetInnerHTML={{ 
            __html: windowWidth <= 635 && mobileSubtitle ? mobileSubtitle : subtitle 
          }} />
        </div>
      </div>

      {!hideWaves && (
        <div>
          <svg
            style={styles.waves}
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 24 150 28"
            preserveAspectRatio="none"
            shapeRendering="auto"
          >
            <defs>
              <path
                id="gentle-wave"
                d="M-160 44c30 0 58-18 88-18s 58 18 88 18 58-18 88-18 58 18 88 18 v44h-352z"
              />
            </defs>
            <g className="parallax">
              <use xlinkHref="#gentle-wave" x="48" y="0" fill="rgba(255,255,255,0.7)" />
              <use xlinkHref="#gentle-wave" x="48" y="1" fill="rgba(255,255,255,0.5)" />
              <use xlinkHref="#gentle-wave" x="48" y="2" fill="rgba(255,255,255,0.3)" />
              <use xlinkHref="#gentle-wave" x="48" y="3" fill="rgba(255,255,255,0.2)" />
              <use xlinkHref="#gentle-wave" x="48" y="4" fill="rgba(255,255,255,0.1)" />
              <use xlinkHref="#gentle-wave" x="48" y="5" fill="rgba(255,255,255,0.1)" />
              <use xlinkHref="#gentle-wave" x="48" y="6" fill="#f9f9f9" />
            </g>
          </svg>
        </div>
      )}
    </div>
  );
};

export default Header;